import { ReactNode } from 'react';

export interface TimelineRowProps {
  children: ReactNode;
}

export default function TimelineRow({ children }: TimelineRowProps) {
  return <tr>{children}</tr>;
}
